'use strict';

var _classCallCheck = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\gssak\\Desktop\\block-image\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var assert = require('assert');

var withIs = require('class-is');

var addNamedLink = require('./addNamedLink');

var visibility = require('../visibility');

var DAGNode =
/*#__PURE__*/
function () {
  function DAGNode(data, links, serializedSize) {
    var _this = this;

    _classCallCheck(this, DAGNode);

    if (serializedSize !== 0) {
      assert(serializedSize, 'A DAGNode requires it\'s serialized size');
    }

    this._data = data || Buffer.alloc(0);
    this._links = links;
    this._serializedSize = serializedSize; // Make sure we have a nice public API that can be used by an IPLD resolver

    visibility.hidePrivateFields(this);
    visibility.addEnumerableGetters(this, ['Data', 'Links']); // Add getters for existing links by the name of the link
    // This is how paths are traversed in IPFS. Links with names won't
    // override existing fields like `data` or `links`.

    links.forEach(function (link, position) {
      addNamedLink(_this, link.Name, position);
    });
  }

  _createClass(DAGNode, [{
    key: "toJSON",
    value: function toJSON() {
      if (!this._json) {
        this._json = Object.freeze({
          data: this.Data,
          links: this._links.map(function (l) {
            return l.toJSON();
          }),
          size: this.size
        });
      }

      return Object.assign({}, this._json);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "DAGNode <data: \"".concat(this.Data.toString('base64'), "\", links: ").concat(this.Links.length, ", size: ").concat(this.size, ">");
    }
  }, {
    key: "size",
    get: function get() {
      if (this._size === undefined) {
        this._size = this._links.reduce(function (sum, l) {
          return sum + l.Tsize;
        }, this._serializedSize);
      }

      return this._size;
    },
    set: function set(size) {
      throw new Error("Can't set property: 'size' is immutable");
    } // Getters for backwards compatible path resolving

  }, {
    key: "Data",
    get: function get() {
      return this._data;
    },
    set: function set(_) {
      throw new Error("Can't set property: 'Data' is immutable");
    }
  }, {
    key: "Links",
    get: function get() {
      return this._links.map(function (link) {
        return {
          Name: link.Name,
          Tsize: link.Tsize,
          Hash: link.Hash
        };
      });
    },
    set: function set(_) {
      throw new Error("Can't set property: 'Links' is immutable");
    }
  }]);

  return DAGNode;
}();

exports = module.exports = withIs(DAGNode, {
  className: 'DAGNode',
  symbolName: '@ipld/js-ipld-dag-pb/dagnode'
});
exports.create = require('./create');
exports.clone = require('./clone');
exports.addLink = require('./addLink');
exports.rmLink = require('./rmLink');